import Image from 'next/image'

import clsx from 'clsx'

import { isDevelopment } from '@/utils/isDevelopment'

import { Warning } from '@/components/Warning'

import { useEntry } from '../Theme.hooks'

type Props = {
	className?: string
}

export const ThemeImagePreview = ({ className }: Props) => {
	const entry = useEntry()

	if ('error' in entry) {
		if (isDevelopment()) return <Warning className={className}>{entry.error}</Warning>
		return null
	}

	if (!entry.data) return null

	return (
		<div className={clsx(className, 'flex max-md:flex-col items-center gap-8 md:items-end my-20')}>
			{/* Large image */}
			<div className="h-[525px] grow max-md:w-full relative">
				<Image
					src={entry.data.largePreview!}
					alt={entry.data.title || 'Theme preview'}
					fill
					objectFit="contain"
				/>
			</div>

			{entry.data.mobilePreview && (
				<div className="bg-[url('/mm/images/device_iphone.png')] w-[176px] h-[359px] shrink-0 bg-contain pt-11 pl-3">
					<div className="relative h-full w-full">
						<Image
							src={entry.data.mobilePreview!}
							alt={entry.data.title || 'Theme preview'}
							height={270}
							width={152}
							sizes="152"
							objectFit="contain"
						/>
					</div>
				</div>
			)}
		</div>
	)
}
